import { toCurrency} from '@/shared/helpers'
const currencyCell = ({ value }) => toCurrency(value);
export const TABLE_COLUMNS = [
  {
    Header: "Date",
    accessor: "posting_timestamp",
  },
  {
    Header: "From Program",
    accessor: "from_program_name",
  },
  {
    Header: "To Program",
    accessor: "to_program_name",
  },
  {
    Header: "Amount Transferred",
    accessor: "amount_transferred",
    Cell: currencyCell,
  },
  {
    Header: "Event Name",
    accessor: "event_name",
  },
  {
    Header: "Awarded By",
    accessor: "awarded_by",
  },
  {
    Header: "Awarded To",
    accessor: "awarded_to",
  },
  {
    Header: "Points",
    accessor: "points_awarded",
  },
  {
    Header: "Dollar Value",
    id: "reward_value",
    accessor: "amount_transferred",
    Cell: currencyCell,
  },
];
